import React, { useEffect, useState } from "react";
import Style from "../../style/traveldetail.module.scss";

const travelogues = [
  {
    title: "5 Must-Visit Haunted places in India – A Top-down Trip!",
    author: "PoornimaTM",
    posted: "7 yrs ago",
    category: "Sulekha",
    link: "/travelogues/haunted-places",
  },
  {
    title: "A Spiritual Sojourn to Varanasi",
    author: "Ravi Shankar",
    posted: "5 yrs ago",
    category: "Travel Log",
    link: "/travelogues/varanasi",
  },
  {
    title: "Exploring the Northeast: Meghalaya Diaries",
    author: "Anjali Rao",
    posted: "2 yrs ago",
    category: "Adventure",
    link: "/travelogues/meghalaya-diaries",
  },
];

const TravelDetail = () => {
  const [data, setData] = useState<any>({ agencies: [] });

  useEffect(() => {
    fetch("/data/travel.json")
      .then((res) => res.json())
      .then((res) => setData(res));
  }, []);

  const getUniqueRoutes = () => {
    const allRoutes = data.agencies.flatMap(
      (agency: any) => agency.popular_routes || []
    );
    const uniqueRoutes = Array.from(new Set(allRoutes));
    return uniqueRoutes.slice(0, 6); // limit to 6
  };

  const displayRoutes: any = getUniqueRoutes();

  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        {/* Left Section: Book Tickets and About Bipko Travels */}
        <div className={Style.leftSection}>
          <section className={Style.ticketSection}>
            <h2 className={Style.sectionTitle}>Book Tickets</h2>
            <div className={Style.ticketList}>
              {displayRoutes.map((route: string, idx: number) => (
                <div key={idx} className={Style.ticketCard}>
                  <a
                    href={`/book-tickets/${route}`}
                    className={Style.ticketCardLink}
                  >
                    {route}
                  </a>
                </div>
              ))}
            </div>
          </section>

          <section className={Style.aboutSection}>
            <h2 className={Style.sectionTitle}>About Bipko Travels</h2>
            <p className={Style.aboutText}>
              Bipko Travels is your all-in-one travel partner, dedicated to
              making every journey seamless, memorable, and affordable. We
              provide a curated platform where travelers can discover and
              connect with verified agents who offer a broad range of services
              across destinations worldwide.
              <br />
              <br />
              Whether you’re booking an international vacation, planning a
              honeymoon, organizing a group tour, or seeking assistance with
              Hajj and Umrah, Bipko ensures that your travel needs are handled
              with professionalism and transparency.
            </p>
          </section>
        </div>

        {/* Right Section: Latest Travelogues */}
        <div className={Style.rightSection}>
          <section className={Style.traveloguesSection}>
            <h2 className={Style.sectionTitle}>Latest Travelogues</h2>
            <ul className={Style.traveloguesList}>
              {travelogues.map((log, idx) => (
                <li key={idx} className={Style.travelogueItem}>
                  <a href={log.link} className={Style.travelogueTitle}>
                    {log.title}
                  </a>
                  <p className={Style.travelogueMeta}>
                    posted {log.posted} by {log.author} in {log.category}
                  </p>
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TravelDetail;
